import React from 'react';
import PropTypes from 'prop-types';

const UserProfileImage = ({ userImage, username }) => (
    <span className="user-pict-32">
        {userImage ?
            (<img src={userImage} alt={username}/>) :
            (<span className="missing-image-user">{username ? username.substring(0, 1) : 'x'}</span>)
        }
    </span>
);

UserProfileImage.propTypes = {
    userImage: PropTypes.string,
    username: PropTypes.string
};

export default UserProfileImage;



// WEBPACK FOOTER //
// ./src/reviews/reviews_list/NewReviewItem/UserProfileImage.js